export default {
	TABLE_TITLE: 'Workforce news',
	WORKFORCE_NEWS_ADDED: 'Workforce news added',
	WORKFORCE_NEWS_EDITED: 'Workforce news edited',
	WORKFORCE_NEWS_DELETED: 'Workforce news deleted'
};
